import request from './request';

export function stats() {
  return request.get('/merchant/dashboard/stats');
}

export function listAgents() {
  return request.get('/merchant/agent/list');
}

export function createAgent(payload) {
  return request.post('/merchant/agent/create', payload);
}

export function updateAgent(id, payload) {
  return request.post(`/merchant/agent/${id}/update`, payload);
}

export function transferAllConversations(fromAgentId, toAgentId) {
  return request.post(`/merchant/agent/${fromAgentId}/transfer-all`, { to_agent_id: toAgentId });
}

export function quickReplies() {
  return request.get('/merchant/quick-reply/list');
}

export function createQuickReply(payload) {
  return request.post('/merchant/quick-reply/create', payload);
}

export function updateQuickReply(id, payload) {
  return request.post(`/merchant/quick-reply/${id}/update`, payload);
}

export function deleteQuickReply(id) {
  return request.post(`/merchant/quick-reply/${id}/delete`);
}

export function faqList() {
  return request.get('/merchant/faq/list');
}

export function createFaq(payload) {
  return request.post('/merchant/faq/create', payload);
}

export function updateFaq(id, payload) {
  return request.post(`/merchant/faq/${id}/update`, payload);
}

export function deleteFaq(id) {
  return request.post(`/merchant/faq/${id}/delete`);
}

export function getWidgetSnippet(host, wsHost, h5Host) {
  const params = { host, ws_host: wsHost };
  const h = (h5Host || '').trim();
  if (h) params.h5_host = h;
  return request.get('/merchant/widget/snippet', { params });
}

